export default "__VITE_ASSET__Dn5$XxCO__"